import { classNames } from '@/msgdeskRuntime/legacyBridge/SelectorContracts'
import { contract } from '../../Editor.helpers'
import { useEditorSurface } from '../../EditorSurfaceContext'

// Hidden compat hooks legacy still addresses by id. Kept off-screen via the
// Recipients block's .md-to__compat rule.
export function RecipientCompatControls() {
  const { skin } = useEditorSurface()
  return (
    <div className={classNames('md-to__compat', skin.recipients.compat)}>
      <span {...contract('editor.recipients.button')} />
      <span {...contract('editor.recipients.span')} />
      <span {...contract('editor.recipients.checkButton')} />
      <span {...contract('editor.recipients.emailCheck')} />
      <span {...contract('editor.recipients.msgCheck')} />
    </div>
  )
}
